'use strict';

var React = require('react');

var SvgAlertMinor = function SvgAlertMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 1 0 1.5 0v-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
  }));
};
SvgAlertMinor.displayName = "AlertMinor";

exports.SvgAlertMinor = SvgAlertMinor;
